import ReactDOM from 'react-dom';

export const scrollToTop = () => {
  return window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};

/**
 * Smooth scroll till the id of the div.
 * @param id id of the div. Eg: #id
 */
export function scrollToElement(id: string) {
  const section = document.querySelector(id);
  section?.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
}

export const createReactFormatter =
  (fn: Function) =>
  (rowIndex: number, rowData: object, lastElement: object) => {
    if (!lastElement) {
      lastElement = document.createElement('div');
    }
    const jsx = fn(rowIndex, rowData);
    ReactDOM.render(jsx, lastElement as HTMLDivElement);
    return { element: lastElement };
  };

export const renderJsx =
  (funct: Function) =>
  (rootDiv: HTMLDivElement, rowData: any, index: number) => {
    const jsx = funct(index, rowData);
    ReactDOM.render(jsx, rootDiv);
  };
